module.exports = __webpack_public_path__ + "100b804b24a089587d4a2022f90062e2.png";